import { VersionReportPageType } from '../../../../../../domain/entity/version-report/VersionReportVersionEntity'
import { colorPalette } from '../../../../../style/colorPalette'

export const PAGE_TYPE_LABELS = {
  PROGRESS_OVERVIEW: '進捗概況',
  PROGRESS_REPORT_BY_PROCESS: '工程別進捗状況',
  PROGRESS_REPORT_BY_TEAM: 'チーム別進捗状況',
  PROGRESS_REPORT_BY_TICKET_LIST: 'チケット管理表別進捗状況',
} as const

export const PAGE_TYPE_SHORT_LABELS: Record<VersionReportPageType, string> = {
  PROGRESS_OVERVIEW: '概況',
  PROGRESS_REPORT_BY_PROCESS: '工程別',
  PROGRESS_REPORT_BY_TEAM: 'チーム別',
  PROGRESS_REPORT_BY_TICKET_LIST: 'チケット管理表別',
}

export type PageTypeLabel =
  (typeof PAGE_TYPE_LABELS)[keyof typeof PAGE_TYPE_LABELS]

export const PAGE_TYPE_MAPPING = {
  [PAGE_TYPE_LABELS.PROGRESS_OVERVIEW]: 'PROGRESS_OVERVIEW',
  [PAGE_TYPE_LABELS.PROGRESS_REPORT_BY_PROCESS]: 'PROGRESS_REPORT_BY_PROCESS',
  [PAGE_TYPE_LABELS.PROGRESS_REPORT_BY_TEAM]: 'PROGRESS_REPORT_BY_TEAM',
  [PAGE_TYPE_LABELS.PROGRESS_REPORT_BY_TICKET_LIST]:
    'PROGRESS_REPORT_BY_TICKET_LIST',
} as const satisfies Record<PageTypeLabel, VersionReportPageType>

export const PAGE_TYPE_COLORS: Record<VersionReportPageType, string> = {
  PROGRESS_OVERVIEW: colorPalette.green[5],
  PROGRESS_REPORT_BY_PROCESS: colorPalette.blue[7],
  PROGRESS_REPORT_BY_TEAM: colorPalette.yellow[4],
  PROGRESS_REPORT_BY_TICKET_LIST: colorPalette.skyBlue[7],
}
